import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';

import { media } from '../../helpers';

import Wave from '../../../images/waves/home-top-wave.inline.svg';

const BrandedContentRowsContainer = styled.div`
    background-color: #f2f0eb;
    padding-bottom: 100px;
    position: relative;
    ${media.large`top: -25vh; margin-bottom: -25vh;`}

    &.no-pad {
        padding-bottom: 0;
    }
    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;

            path {
                mask: none;
                opacity: 1;
                fill: #fff;
            }
        }
    }

    > .content-container {
        text-align: center;
        padding: 100px 0 70px;
        position: relative;

        ${media.medium`max-width: 650px; top: -10vh;margin-bottom: -10vh; padding: 100px 0 70px;`}

        h3 {
            font-size: 2.2rem;
            margin: 0 0 20px;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            color: #000;
        }

        p {
            font-size: 0.9rem;
        }
    }

    .content-row-wrapper {
        max-width: 450px;
        ${media.large`display: flex; max-width: 70vw;`}
        margin-bottom: 70px;

        &.flipped {
            .image-container {
                order: 2;
            }
            .content-container {
                order: 1;
            }
        }

        &:last-child {
            margin-bottom: 0px;
        }

        .image-container {
            flex: 1;
        }
        > .content-container {
            flex: 1;
            display: flex;
            align-items: center;

            .inner-wrap {
                margin: 0 auto;
                padding: 20px 10px 0;
                max-width: 450px;

                h3 {
                    font-size: 2rem;
                    font-family: neue-kabel, sans-serif;
                    color: #000;
                    margin: 0 0 15px;
                    line-height: 1.3;
                    font-weight: 800;
                    ${media.large`font-size: 2.8rem; line-height: 1;`};
                }

                p {
                    font-size: 1.1rem;
                    line-height: 1.5;
                }
            }
        }
    }
`;

const BrandedContentRows = ({ rows }) => {
    function isOdd(num) {
        return num % 2;
    }

    return (
        <BrandedContentRowsContainer>
            <div className="svg-container">
                {/* <Parallax
                    className="custom-class"
                    y={[-40, 20]}
                    // x={[-40, 20]}
                    tagOuter="figure"
                >
                </Parallax> */}
                <Wave />
            </div>
            {rows &&
                rows.map((row, index) => {
                    const {
                        contentRowImage,
                        contentRowTitle,
                        contentRowDescription,
                    } = row || {};

                    let isProductOdd = isOdd(index);
                    return (
                        <Wrapper
                            className={
                                !isProductOdd
                                    ? 'content-row-wrapper flipped'
                                    : 'content-row-wrapper'
                            }
                        >
                            <div className="image-container">
                                <Img
                                    fluid={
                                        contentRowImage.localFile
                                            .childImageSharp.fluid
                                    }
                                />
                            </div>
                            <div className="content-container">
                                <div className="inner-wrap">
                                    <h3>{contentRowTitle}</h3>
                                    <p>{contentRowDescription}</p>
                                </div>
                            </div>
                        </Wrapper>
                    );
                })}
        </BrandedContentRowsContainer>
    );
};

export default BrandedContentRows;
